import { Link } from 'react-router-dom';
import MetricState from '../common/MetricState';
import ProgressMeter from '../common/ProgressMeter';
import useMetric from '../../hooks/useMetric';
import { formatCompact, formatCurrency } from '../../utils/format';

export default function AiUsageCostIndicator() {
  const { status, data, error, retry } = useMetric('aiUsage');
  const tokenPct = data ? (data.tokensUsed / data.tokensQuota) * 100 : 0;
  const costPct = data ? (data.cost / data.budget) * 100 : 0;
  const over = Math.max(tokenPct, costPct);

  return (
    <section className="cb-card h-100" data-testid="kpi-ai-usage" aria-label="AI usage and cost">
      <header className="d-flex align-items-center gap-2 mb-2">
        <span className="cb-icon-tile cb-icon-tile--info" aria-hidden="true"><i className="bi bi-cpu" /></span>
        <h3 className="cb-kpi__title mb-0">AI Usage &amp; Cost</h3>
        <Link to="/settings" className="ms-auto small text-decoration-none" aria-label="Manage billing and plan">
          <i className="bi bi-arrow-right-short fs-5" aria-hidden="true" />
        </Link>
      </header>
      <MetricState status={status} error={error} onRetry={retry} emptyText="No AI usage recorded this period." minHeight={120}>
        {data && (
          <>
            <ProgressMeter label="Tokens" percent={tokenPct} valueText={`${formatCompact(data.tokensUsed)} / ${formatCompact(data.tokensQuota)}`} />
            <ProgressMeter label="Cost" percent={costPct} valueText={`${formatCurrency(data.cost)} / ${formatCurrency(data.budget)}`} />
            <div className="small text-muted d-flex justify-content-between">
              <span>{data.periodLabel}</span>
              {over >= 100 ? (
                <span className="text-danger fw-medium" role="alert">Limit reached</span>
              ) : over >= 80 ? (
                <span className="text-warning-emphasis fw-medium">Approaching limit</span>
              ) : (
                <span>Within budget</span>
              )}
            </div>
          </>
        )}
      </MetricState>
    </section>
  );
}
